import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import Login from "./component";
import { useNavigate } from "react-router-dom";
import {
  setLoading,
  onMobileChange,
  onPasswordChange,
  saveUser,
} from "./action";
import { getDataFromAPI } from "../../../HandleAPICalls/actions";
import Axios from "axios";
import { toast } from "react-toastify";
import { jwtDecode } from "jwt-decode";




const LoginContainer = (props) => {
  const [auth, setAuth] = useState(localStorage.getItem("data"));
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const loginTime = localStorage.getItem("loginTime");
    const currentTime = new Date().getTime();

    if (loginTime) {
      const elapsedTime = currentTime - parseInt(loginTime, 10);
      const twentyFourHours = 24 * 60 * 60 * 1000;

      if (elapsedTime > twentyFourHours) {

        localStorage.removeItem("data");
        localStorage.removeItem("loginTime");


        toastr.warning("Session expired. Please login again.");
        navigate("/");
      }
    }
  }, [navigate]);

  const onChanegOfMobile = (e) => {
    const { value } = e.target;
    props.onMobileChange(value);
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      onSubmit(event);
    }
  };

  const onChangeOfPassword = (e) => {
    const { value } = e.target;
    props.onPasswordChange(value);
  };

  const callPermissionApi = (data) => {
    let params = {
      "access-token": data.accessToken,
    };
    Axios.post("/dashboard/api/v2/admin/auth/permissions", params, {
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((res) => {
        localStorage.setItem("allPermissions", JSON.stringify(res.data.data));
      })
      .catch((err) => {
        console.log("error faced while requesting -->>>", err);
      });
  };
 

  const onSubmit = (e) => {
    e.preventDefault();
    const mobile = props.login.mobile;
    const password = props.login.password;
    const payload = { mobile, password };

    const regex = /^([+]?[\s0-9]+)?(\d{3}|[(]?[0-9]+[)])?([-]?[\s]?[0-9])+$/i;
    if (!mobile || regex.test(mobile) === false) {
      toastr.warning("Mobile Number is Required to Login on Daalchini");
      return;
    }
    if (!password || password.length < 6) {
      toastr.warning("Password is Required to Login on Daalchini");
      return;
    }
    setLoading(true);
    props.getDataFromAPI(
      "/dashboard/api/v2/admin/login",
      "POST",
      payload,
      (response) => {
        const currentTime = new Date().getTime();
        localStorage.setItem("loginTime", currentTime);

        const decoded = jwtDecode(response.accessToken);
        console.log("Decoded JWT Payload:", decoded);

        const userPermissions = decoded.permissions || [];
        console.log("User Permissions:", userPermissions);

        localStorage.setItem("userPermissions", JSON.stringify(userPermissions));


        // baki tera flow
        // callPermissionApi(response);
        localStorage.setItem("data", JSON.stringify(response));
        props.saveUser(response);
        setLoading(false);
        navigate("/home");
      },
      (err) => {
        toastr.error(`${err.data.message}`, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 1000,
        });
        setLoading(false);
      },
      true
    );
  };

  return (
    <Login
      mobile={props.login.mobile}
      password={props.login.password}
      disabled={false}
      loading={false}
      onChanegOfMobile={onChanegOfMobile}
      onChangeOfPassword={onChangeOfPassword}
      onSubmit={onSubmit}
      handleKeyDown={handleKeyDown}
      showPassword={showPassword}
      setShowPassword={setShowPassword}
    />
  );
};

function mapStateToProps({ login }) {
  return {
    login,
  };
}

export default connect(mapStateToProps, {
  setLoading,
  onMobileChange,
  onPasswordChange,
  saveUser,
  getDataFromAPI,
})(LoginContainer);
